import * as React from 'react';

import {
  Button,
  cn,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  ThemeColor,
} from '@rematter/ui-web';
import { CircleCheckBig, LucideProps } from 'lucide-react';

interface SalesOrderGenericDialogProps {
  onConfirm: () => Promise<void>;
  onCancel?: () => void;
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  color?: ThemeColor;
  icon?: React.ReactElement<LucideProps>;
  className?: string;
}

export const SalesOrderGenericDialog: React.FC<
  SalesOrderGenericDialogProps
> = ({
  onConfirm,
  onCancel,
  message,
  title,
  confirmLabel,
  cancelLabel,
  color = 'success',
  icon = <CircleCheckBig className="size-4 text-success" />,
  className,
}) => (
  <DialogOverlay isOpen className={cn('@SalesOrderGenericDialog', className)}>
    <DialogContent className="max-w-sm" closeButton={false}>
      <DialogHeader>
        <div className="flex items-center gap-1.5">
          {icon}
          <div className="text-base font-semibold">{title}</div>
        </div>
      </DialogHeader>
      <div className="flex flex-col gap-2 px-4">
        <div className="text-base text-neutral/75">{message}</div>
        <div className="flex justify-end gap-2 py-4">
          <Button
            variant="outline"
            color="neutral"
            onPress={() => onCancel?.()}
          >
            {cancelLabel}
          </Button>
          <Button variant="solid" color={color} onPress={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </DialogContent>
  </DialogOverlay>
);
